import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../css/login.css';
import '../css/verify-code.css';
import logo from '../image/logo_alo.png';
import test1 from '../image/judge-3.gif';
import { Button, Card, Image } from 'react-bootstrap';
import AuthCode from 'react-auth-code-input';
import { resendCode, verify2FACode } from '../services/User_service';
import { FaEnvelope } from 'react-icons/fa';
import axios from 'axios';
import verifycode from '../image/mot-de-passe.png'

const VerifyCode: React.FC = () => {
    const [result, setResult] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState({
        verifying: false,
        resending: false
    });
    const userEmail = localStorage.getItem("userEmail");
    const navigate = useNavigate();

    const handleOnChange = (res: any) => {
        setResult(res);
    };

    const handleOnSubmit = async () => {
        if (result?.length === 6) {
            if (userEmail) {
                setIsLoading((prev) => ({ ...prev, verifying: true }));
                const response = await verify2FACode(result, userEmail);
                if (response && response.status === 200) {
                    navigate("/home");
                }
                setIsLoading((prev) => ({ ...prev, verifying: false }));
            } else {
                navigate("/login");
            }
        }
    };

    const handleOnResend = async () => {
        try {
            setIsLoading((prev) => ({ ...prev, resending: true }));
            const response = await resendCode();
            if (response && response.status === 200) {
                setIsLoading((prev) => ({ ...prev, resending: false }));
                toast.success("Un nouveau code a été envoyé à votre adresse e-mail.");
            }
        } catch (error: any) {
            if (axios.isAxiosError(error)) {
                toast.error(error.response?.data.message || "Une erreur est survenue lors de l'envoi du code.");
            } else {
                toast.info("Veuillez vous connecter pour renvoyer le code.");
                setIsLoading((prev) => ({ ...prev, resending: false }));
                setTimeout(() => {
                    navigate("/login");
                }, 2000);
            }
        }
    };

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            const inputs = document.querySelectorAll('.auth-code input');

            // Gestion du Delete/Backspace pour effacer tous les champs
            if (e.key === 'Backspace' || e.key === 'Delete') {
                const activeInput = document.activeElement as HTMLInputElement;
                const activeIndex = Array.from(inputs).indexOf(activeInput);
                
                // Si le champ actif est vide, effacer tous les champs
                if (activeInput && activeInput.value === '') {
                    inputs.forEach((input) => {
                        (input as HTMLInputElement).value = '';
                    });
                    setResult('');
                    (inputs[0] as HTMLInputElement).focus();
                    e.preventDefault();
                } else if (activeInput && activeInput.value !== '') {
                    // Si le champ actif contient une valeur, la supprimer
                    activeInput.value = '';
                    const event = new Event('input', { bubbles: true });
                    activeInput.dispatchEvent(event);
                    e.preventDefault();
                }
            }

            // Gestion de la touche Entrée
            if (e.key === 'Enter' && result?.length === 6 && !isLoading.verifying) {
                handleOnSubmit();
            }
        };

        const handlePaste = (e: ClipboardEvent) => {
            const pastedData = e.clipboardData?.getData('text');
            const inputs = document.querySelectorAll('.auth-code input');
            
            if (pastedData && /^\d+$/.test(pastedData)) {
                e.preventDefault();
                
                // Effacer tous les champs existants avant de coller
                inputs.forEach((input) => {
                    (input as HTMLInputElement).value = '';
                });
                
                // Remplir les champs avec les nouvelles données
                const digits = pastedData.split('').slice(0, 6);
                digits.forEach((digit, index) => {
                    if (inputs[index]) {
                        (inputs[index] as HTMLInputElement).value = digit;
                        const event = new Event('input', { bubbles: true });
                        (inputs[index] as HTMLInputElement).dispatchEvent(event);
                    }
                });
                
                // Mettre le focus sur le dernier champ rempli ou le suivant
                const lastFilledIndex = Math.min(digits.length - 1, 5);
                const nextIndex = Math.min(digits.length, 5);
                if (digits.length < 6 && inputs[nextIndex]) {
                    (inputs[nextIndex] as HTMLInputElement).focus();
                } else {
                    (inputs[lastFilledIndex] as HTMLInputElement).focus();
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('paste', handlePaste);
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('paste', handlePaste);
        };
    }, [result, isLoading.verifying]);


    return (
        <>
            <ToastContainer />
            <div className="degrade-vertical big-height">
                <div className="row col-section d-flex flex-column-reverse flex-md-row justify-content-center align-items-center">
                    <div className="col-md-6 col-sm-12 d-flex section-txt mt-5">
                        <div className="bg-section section-tab my-5">
                            <div className="img-animate">
                                <img src={test1} alt="png" className="img-fluid w-100 ImgGif" />
                            </div>
                            <div className="text-title">
                                <h1 className="font-1">Annonce Legale <br /> Officielle</h1>
                                <p className="font-2">Bénéficiez d'une publication instantanée dans toute la France,
                                    grâce à notre plateforme sécurisée en ligne, disponible 24/7 et adaptée à tout type
                                    d'annonce, des plus simples aux plus complexes.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-12 d-flex bg-verifiermail section-txt">
                        <div className="p-3">
                            <Image src={logo} style={{ width: "100px" }} />
                        </div>

                   <Card className="verification-card mx-auto mb-3">
                        <div className="text-center pt-4">
                            <img src={verifycode} alt="Vérification" className="verification-img" />
                        </div>

                        <Card.Body>
                            <Card.Title className="text-center mt-3">Authentification de l'adresse e-mail</Card.Title>
                            <Card.Subtitle className="text-center text-muted">
                            Entrez le code envoyé à votre adresse e-mail pour continuer.
                            </Card.Subtitle>

                            <div className="authcode-container mt-4 text-center">
                            <AuthCode
                                containerClassName='auth-code'
                                onChange={handleOnChange}
                                isPassword={false}
                                autoFocus
                            />
                            </div>

                            <div className="alert alert-info text-center mx-auto info-box mt-3">
                            Ce code n'est valable que pendant <b>5 minutes</b>.<br />
                            Si le temps est écoulé, veuillez demander un renvoi du code.
                            </div>

                            <div className="text-center mt-4">
                            <Button
                                disabled={isLoading.verifying}
                                variant="primary"
                                onClick={handleOnSubmit}
                            >
                                {isLoading.verifying ? "Vérification..." : "Continuer"}
                            </Button>
                            </div>

                            <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">
                            <Button
                                variant="outline-secondary"
                                className="btn-custom-back d-flex align-items-center gap-1"
                                onClick={() => navigate(-1)}
                            >
                                <svg width="16" height="16" fill="#4BB0C0" viewBox="0 0 16 16">
                                <path d="M11 8a.5.5 0 0 1-.5.5H4.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L4.707 7.5H10.5A.5.5 0 0 1 11 8z" />
                                </svg>
                                Retour
                            </Button>

                            <Button
                                disabled={isLoading.resending}
                                className="btn-custom-resend d-flex align-items-center gap-1"
                                onClick={handleOnResend}
                            >
                                {isLoading.resending
                                ? "Envoi..."
                                : <>
                                    <FaEnvelope className="email-icon" />
                                    Renvoyer le code
                                    </>
                                }
                            </Button>
                            </div>
                        </Card.Body>
                        </Card>

                    </div>
                </div>
            </div>
        </>
    );
};

export default VerifyCode;